export { FullImage } from '@/components/common/LandingPageHero/versions/FullImage';
export { SideBySide } from '@/components/common/LandingPageHero/versions/SideBySide';
export { ContainedImage } from '@/components/common/LandingPageHero/versions/ContainedImage';
